<template>
    <div class="page-content">
        <SidebarLayout/>
        <div class="chartSection">
            <RepositoryBreadcrumbsLayout/>
            <div class="row g-0">
                <div class="col">
                    <div class="title-col2">
                        <h2 class="md-title">New repositories</h2>
                        <span class="sm-text">Enter details of your new repository</span>
                    </div>
                </div>
            </div>
            <form @submit.prevent="submit">
                <div class="new-repository-box">
                    <div class="box-title">
                        <h4>Repository Name</h4>
                        <input id="name" type="text" v-model="form.name"  placeholder="Type here" class="box-input-style input-style form-control">

                        <div v-if="form.errors.name" v-bind:style="styleObject">{{ form.errors.name }}</div>

                        <!-- <small class="required">Invalid repository name. Please follow guidance in a field footnote.</small> -->
                    </div>

                    <p class="box-text">
                        Please enter the name of the repository for your reference. It could be name of the team, project or anything really. 
                    </p>
                    
                    <div class="box-title">
                        <h4>Repository Slug</h4>
                        <input id="name" type="text" v-model="form.slug" placeholder="Type here" class="box-input-style input-style form-control">
                        <div v-if="form.errors.slug" v-bind:style="styleObject">{{ form.errors.slug }}</div>
                        <!-- <small class="required">Invalid repository name. Please follow guidance in a field footnote.</small> -->
                    </div>

                    <p class="box-text">
                        Repository slug must be unique acrros the platform, and must meet URL requirments. It is case insensitive. Must include only latin letters, numbers and dashes for better compatibility. 
                        Example: acme-web-portal
                    </p>
                    <div class="btn-icon-style btn-padding">
                        <!-- <a href="javascript:void(0)" class="btn btn-style btn-secondery w_210">
                            <span>Create Repository</span>
                        </a> -->
                        <button class="btn btn-style btn-secondery w_210" :disabled="form.processing">
                            <span>Create Repository</span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import RepositoryBreadcrumbsLayout from '@/Layouts/RepositoryBreadcrumbsLayout'
import SidebarLayout from '@/Layouts/SidebarLayout'
    export default {
        props: {
            errors: Object,
        },

        components: {
            RepositoryBreadcrumbsLayout,
            SidebarLayout,
        },

        data() {
            return {
                form: this.$inertia.form({
                    name: '',
                    slug: '',
                }),
                styleObject: {
                    color: 'red',
                    fontSize: '15px'
                },
            }
        },

        methods: {
            submit() {
                this.form.post(route('teams.store'), {
                    errorBag: 'createTeam',
                    preserveScroll: true
                });
            },
        },
    }
</script>

